import { useLanguage } from '../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { Compass } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_vocation-guide-1/artifacts/og76lhbc_logo%20neutre.%20.png";

export const Header = () => {
  const { language, setLanguage } = useLanguage();
  const navigate = useNavigate();

  return (
    <header className="w-full py-4 px-6 md:px-12 flex items-center justify-between bg-[#EBEBEB]">
      <button 
        onClick={() => navigate('/')}
        className="flex items-center gap-3 hover:opacity-80 transition-opacity"
        data-testid="header-logo"
      >
        <img 
          src={LOGO_URL} 
          alt="Déclic Logo" 
          className="h-20 md:h-28 w-auto"
        />
      </button>
      
      <div className="flex items-center gap-4">
        {/* Explore Careers Link */}
        <button
          onClick={() => navigate('/explore')}
          className="hidden sm:flex items-center gap-2 px-4 py-2 text-[#A4187A] hover:bg-[#F3E5F5] rounded-lg transition-colors"
          data-testid="explore-link"
        >
          <Compass className="w-5 h-5" />
          <span className="font-medium">
            {language === 'fr' ? 'Explorer' : 'Ontdekken'}
          </span>
        </button>

        {/* Language Switcher */}
        <div className="lang-switch" data-testid="language-switcher">
          <button
            onClick={() => setLanguage('fr')}
            className={language === 'fr' ? 'active' : ''}
            data-testid="lang-fr"
          >
            FR
          </button>
          <button
            onClick={() => setLanguage('nl')}
            className={language === 'nl' ? 'active' : ''}
            data-testid="lang-nl"
          >
            NL
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
